import React, {Component} from 'react';
import validate from './validation';
import {Grid} from 'material-ui';
import {Field, reduxForm} from 'redux-form';
import {InputTextField} from '../../../components/fields/field_input_text';
import {DateTimeField} from '../../../components/fields/field_datetime';
import {Heading} from '../../../components/heading/heading';
import {BackButton} from '../../../components/buttons/BackButton';
import {SaveButton} from '../../../components/buttons/SaveButton';
import {InputTextareaField} from '../../../components/fields/field_input_textarea';
import {Typography} from 'material-ui';
import {MultiSelectField} from '../../../components/fields/field_multi_select_user';

class WebinarEditForm extends Component {
    render() {
        const {
            allSites,
            handleSubmit,
            pristine,
            touched,
            loading,
            initialValues,
        } = this.props;

        const {
            event_title,
            event_short_description,
            start_date,
        } = initialValues;

        return (
            <form onSubmit={handleSubmit(this.props.handleFormSubmit)}>
                <Heading title={'Edit Webinar'} />
                <Grid container id="text-fields">
                    <Grid item xs={12}>
                        <Typography variant="subheading">Title *</Typography>
                        <Field
                            name="event_title"
                            component={InputTextareaField}
                            initialValue={event_title}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="subheading">
                            Meta Description *
                        </Typography>
                        <Field
                            name="event_short_description"
                            component={InputTextareaField}
                            initialValue={event_short_description}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="subheading">When *</Typography>
                        <Field
                            name="start_date"
                            component={DateTimeField}
                            initialValue={start_date}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Field
                            name="event_id"
                            component={InputTextField}
                            label="Event Id"
                            fullWidth={true}
                            InputLabelProps={{
                                required: true,
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid container id="select-fields">
                    <Grid item xs={12} md={4}>
                        <Typography variant="subheading">
                            Choose sites below *:
                        </Typography>
                        <Field
                            name="sites"
                            component={MultiSelectField}
                            options={allSites}
                        />
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12}>
                        <SaveButton
                            type="submit"
                            loading={loading}
                            disabled={(!touched && pristine) || loading}
                            variant="raised"
                            color="primary"
                            className="floatRight"
                        />
                        <BackButton
                            link={'/webinars'}
                            style={{marginRight: 15}}
                            variant="raised"
                            className="floatRight"
                        />
                    </Grid>
                </Grid>
            </form>
        );
    }
}

export default reduxForm({
    form: 'WebinarEditForm',
    enableReinitialize: true,
    destroyOnUnmount: false,
    validate,
})(WebinarEditForm);



// WEBPACK FOOTER //
// ./src/containers/webinars/forms/EditWebinarForm.jsx